import { createSlice } from "@reduxjs/toolkit";
import { paymentMethod, deletePaymentMethod } from "./thunk";

const initialState = {
  paymentMethod: {},
  deletePaymentMethod: {},
  error: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: {
    [paymentMethod.pending]: (state) => {
      state.error = null;
    },

    [paymentMethod.fulfilled]: (state, action) => {
      state.paymentMethod = action.payload;
    },
    [paymentMethod.rejected]: (state, action) => {
      state.error = action.error.message;
    },
    // Delete Payment Method
    [deletePaymentMethod.pending]: (state) => {
      state.error = null;
    },
    [deletePaymentMethod.fulfilled]: (state, action) => {
      state.deletePaymentMethod = action.payload;
    },
    [deletePaymentMethod.rejected]: (state, action) => {
      state.error = action.error.message;
    },
  },
});

export default paymentSlice.reducer;
